// scripting for an individual job that is part of a workflow run
import {reportError} from '@github-ui/failbot'
import './github/workflow-runs/rerequests'
import {loadWorkflowRunsRuntime} from './github/workflow-runs/runtime-loader'

async function initializeWorkflowRuns() {
  try {
    await loadWorkflowRunsRuntime()
  } catch (error) {
    reportError(error)
  }
}

if (typeof document !== 'undefined') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeWorkflowRuns, {once: true})
  } else {
    queueMicrotask(initializeWorkflowRuns)
  }
}
